export default __webpack_public_path__ + "static/media/0104.8836b937.png";